import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuthState } from '../../redux/slices/authSlice';

export default function AuthProvider({ children }) {
  const dispatch = useDispatch();
  const { isInitialized } = useSelector((state) => state.auth);

  useEffect(() => {
    // Check auth state on app load
    dispatch(checkAuthState());
  }, [dispatch]);

  // Show loading screen while checking auth state
  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
